// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"795b4b94","239":"b7b4160a","455":"152ce322","488":"2de1d072"}[chunkId] + ".chunk.js";
};